export default "__VITE_ASSET__DY7kDRZc__"